<template>
    <div class="fm-integrations">
      <!-- Left Sidebar -->
      <div class="fm-sidebar">
        <div class="fm-sidebar-title">{{ t('formychat_modules') }}</div>
        <ul class="fm-category-list">
          <li 
            v-for="category in store.categories" 
            :key="category.slug"
            :class="{ active: store.selectedCategory === category.slug }"
            class="fm-category-item"
          >
            <button class="fm-category-btn" @click="store.selectedCategory = category.slug">
              <span>{{ category.label }}</span>
              <span v-if="store.selectedCategory === category.slug">&#8594;</span>
            </button>
          </li>
        </ul>
      </div>
  
      <!-- Main Content -->
      <div class="fm-content-area">
        <!-- Header -->
        <div class="fm-header">
          <div class="fm-header-content">
            <h1 class="fm-main-title">{{ t('formychat_modules') }}</h1>
            <p class="fm-subtitle">{{ t('integrate_modules_subtitle') }}</p>
          </div>
          <div class="fm-header-actions">
            <a href="https://www.youtube.com/watch?v=bjJcWoY-8zA&list=PLd6WEu38CQSyebRIikg4qX54h-R1n35TG" target="_blank" class="fm-btn fm-btn-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
<path fill="#FF3D00" d="M43.2,33.9c-0.4,2.1-2.1,3.7-4.2,4c-3.3,0.5-8.8,1.1-15,1.1c-6.1,0-11.6-0.6-15-1.1c-2.1-0.3-3.8-1.9-4.2-4C4.4,31.6,4,28.2,4,24c0-4.2,0.4-7.6,0.8-9.9c0.4-2.1,2.1-3.7,4.2-4C12.3,9.6,17.8,9,24,9c6.2,0,11.6,0.6,15,1.1c2.1,0.3,3.8,1.9,4.2,4c0.4,2.3,0.9,5.7,0.9,9.9C44,28.2,43.6,31.6,43.2,33.9z"></path><path fill="#FFF" d="M20 31L20 17 32 24z"></path>
</svg>
              {{ t('tutorial') }}
            </a>
            <a href="https://wppool.dev/docs-category/formychat-documentation/" target="_blank" class="fm-btn fm-btn-secondary">
                <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 48 48">
<linearGradient id="pg10I3OeSC0NOv22QZ6aWa_v0YYnU84T2c4_gr1" x1="-209.942" x2="-179.36" y1="-3.055" y2="27.526" gradientTransform="translate(208.979 6.006)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#55adfd"></stop><stop offset="1" stop-color="#438ffd"></stop></linearGradient><path fill="url(#pg10I3OeSC0NOv22QZ6aWa_v0YYnU84T2c4_gr1)" d="M39.001,13.999v27c0,1.105-0.896,2-2,2h-26	c-1.105,0-2-0.895-2-2v-34c0-1.104,0.895-2,2-2h19l2,7L39.001,13.999z"></path><path fill="#fff" fill-rule="evenodd" d="M15.999,18.001v2.999	h17.002v-2.999H15.999z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M16.001,24.001v2.999	h17.002v-2.999H16.001z" clip-rule="evenodd"></path><path fill="#fff" fill-rule="evenodd" d="M15.999,30.001v2.999	h12.001v-2.999H15.999z" clip-rule="evenodd"></path><linearGradient id="pg10I3OeSC0NOv22QZ6aWb_v0YYnU84T2c4_gr2" x1="-197.862" x2="-203.384" y1="-4.632" y2=".89" gradientTransform="translate(234.385 12.109)" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#427fdb"></stop><stop offset="1" stop-color="#0c52bb"></stop></linearGradient><path fill="url(#pg10I3OeSC0NOv22QZ6aWb_v0YYnU84T2c4_gr2)" d="M30.001,13.999l0.001-9l8.999,8.999L30.001,13.999z"></path>
</svg>
              {{ t('documentation') }}
            </a>
            <a href="https://wordpress.org/plugins/social-contact-form/" target="_blank" class="fm-btn fm-btn-secondary">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="#FFD700"/>
              </svg>
              {{ t('review_us') }}
            </a>
          </div>
        </div>
  
        <!-- Search Bar -->
        <div class="fm-toolbar">
          <div class="fm-search">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21 21l-4.2-4.2" stroke="#7A7A7A" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="11" cy="11" r="7" stroke="#7A7A7A" stroke-width="1.5"/>
            </svg>
            <input 
              v-model="store.searchQuery" 
              type="search" 
              :placeholder="t('search_modules')" 
              class="fm-search-input"
            />
          </div>

        </div>
  
        <!-- Integrations Grid -->
        <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-4">
          <IntegrationCard
            v-for="integration in store.filteredIntegrations"
            :key="integration.id"
            :integration="integration"
            @toggle="store.toggleIntegration"
            @activate="store.installIntegration"
            @install="store.installIntegration"
            @settings="store.openSettings"
          />
          
          <!-- Suggest Integration Card -->
          <div class="bg-white flex flex-col justify-between rounded border overflow-hidden border-gray-200 hover:-translate-y-1 hover:shadow transition-all duration-300">
            <div class="flex flex-col gap-3 p-5">
              <div class="bg-gray-600 w-12 h-12 rounded-full text-white flex items-center justify-center"><svg xmlns="http://www.w3.org/2000/svg" class="fill-current w-8" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M4.475 5.458c-.284 0-.514-.237-.47-.517C4.28 3.24 5.576 2 7.825 2c2.25 0 3.767 1.36 3.767 3.215 0 1.344-.665 2.288-1.79 2.973-1.1.659-1.414 1.118-1.414 2.01v.03a.5.5 0 0 1-.5.5h-.77a.5.5 0 0 1-.5-.495l-.003-.2c-.043-1.221.477-2.001 1.645-2.712 1.03-.632 1.397-1.135 1.397-2.028 0-.979-.758-1.698-1.926-1.698-1.009 0-1.71.529-1.938 1.402-.066.254-.278.461-.54.461h-.777ZM7.496 14c.622 0 1.095-.474 1.095-1.09 0-.618-.473-1.092-1.095-1.092-.606 0-1.087.474-1.087 1.091S6.89 14 7.496 14"/>
</svg></div>
              <h3 class="font-semibold text-base flex items-center gap-2">{{ t('dont_see_tool') }}</h3>
              <p class="text-sm text-gray-500">{{ t('suggest_integration_text') }}</p>
            </div>
            <a href="https://wordpress.org/support/plugin/social-contact-form/" @click.prevent="handleSuggestNowButton" target="_blank" class="flex w-full">
              <div class="w-full bg-gray-600 hover:bg-gray-700 transition-all duration-300 text-white px-4 h-[60px] flex items-center justify-center text-center font-semibold">{{ t('suggest_now') }} &#8594;</div>
            </a>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Toast Notifications -->
    <Toast />
    
    <!-- Integration Settings Modal -->
    <IntegrationModal />

    <Upgrade/>
  </template>
  
  <script setup>
  import { onMounted, watch } from 'vue'
  import { IntegrationCard, Upgrade, Toast, IntegrationModal } from '@components'
  import { useIntegrations } from '../stores/integrations'
  import { useTranslation } from '../composables/useTranslation'
  
  const { t } = useTranslation()

  // Use the integrations store
  const store = useIntegrations()

  // Load integrations on mount
  onMounted(() => {
    store.loadIntegrations()

    // Check if Google Sheets was just connected via OAuth redirect
    if (formychat_admin_vars?.additional?.google_sheets?.just_connected) {
      // Watch for integrations to load, then open the modal
      const unwatch = watch(
        () => store.integrations,
        (integrations) => {
          if (integrations && integrations.length > 0) {
            const googleSheets = integrations.find(i => i.id === 'google_sheets')
            if (googleSheets) {
              store.openSettings(googleSheets)
            }
            unwatch()
          }
        },
        { immediate: true }
      )
    }
  })

  const handleSuggestNowButton = ( e ) => {
    if (window.Gleap) {
      e.preventDefault();
      Gleap.open();
    } else {
      // Go to the page here.
      window.open(e.target.href || 'https://wordpress.org/support/plugin/social-contact-form/', '_blank')
    }
  }

  </script>
  
  <style scoped>
  .fm-integrations {
    display: grid;
    grid-template-columns: 260px 1fr;
    gap: 24px;
    min-height: 100vh;
    background: #f6f7fb;
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  }
  
  .fm-sidebar {
    background: #ffffff;
    border: 1px solid #e6e8ef;
    border-radius: 8px;
    padding: 16px;
    height: 100vh;
    position: sticky;
    top: 0;
    overflow-y: auto;
  }
  
  .fm-sidebar-title {
    font-weight: 600;
    margin-bottom: 12px;
    color: #1f2937;
    font-size: 16px;
  }
  
  .fm-category-list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  .fm-category-item {
    margin: 0;
    margin-bottom: 4px;
  }
  
  .fm-category-btn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    text-align: left;
    padding: 10px 12px;
    border-radius: 3px;
    border: 1px solid transparent;
    background: transparent;
    cursor: pointer;
    color: #374151;
    font-size: 14px;
    transition: all 0.2s;
  }
  
  .fm-category-item.active .fm-category-btn,
  .fm-category-btn:hover {
    color: #f2f5ff;
    border-color: #5163f1;
    background-color: #5163f1;
  }
  
  .fm-content-area {
    padding: 24px;
    display: flex;
    flex-direction: column;
  }
  
  .fm-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 24px;
  }
  
  .fm-header-content {
    flex: 1;
  }
  
  .fm-main-title {
    font-size: 28px;
    font-weight: 600;
    color: #1f2937;
    margin: 0 0 8px 0;
  }
  
  .fm-subtitle {
    color: #6b7280;
    font-size: 16px;
    margin: 0;
  }
  
  .fm-header-actions {
    display: flex;
    gap: 12px;
    align-items: center;
  }
  
  .fm-btn {
    padding: 8px 16px;
    border-radius: 20px;
    border: 1px solid;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: all 0.2s;
    background: rgb(232, 232, 232);
  }
  
  .fm-btn-secondary {
    border-color: #e5e7eb;
    color: #374151;
  }
  
  .fm-btn-secondary:hover {
    background: #f9fafb;
    border-color: #d1d5db;
  }
  
  .fm-btn-primary {
    background: #5163f1;
    border-color: #5163f1;
    color: white;
  }
  
  .fm-btn-primary:hover {
    background: #4338ca;
    border-color: #4338ca;
  }
  
  .fm-toolbar {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-bottom: 24px;
  }
  
  .fm-search {
    background: #fff;
    border: 1px solid #e6e8ef;
    border-radius: 3px;
    display: flex;
    gap: 8px;
    align-items: center;
    min-width: 300px;
    position: relative;
  }
  .fm-search svg {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
  }
  
  .fm-search-input {
    border: none;
    outline: none;
    flex: 1;
    font-size: 14px;
    color: #374151;
    padding: 8px 12px 8px 40px;
  }
  
  .fm-search-input::placeholder {
    color: #9ca3af;
  }
  

  
  
  /* Responsive Design */
  @media (max-width: 1024px) {
    .fm-integrations {
      grid-template-columns: 1fr;
      gap: 16px;
    }
    
    .fm-sidebar {
      position: static;
      height: auto;
      margin-bottom: 16px;
      padding: 12px;
    }
    
    .fm-content-area {
      padding: 16px;
    }
    
    .fm-header {
      flex-direction: column;
      gap: 16px;
      align-items: stretch;
    }
    
    .fm-header-actions {
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    
    .fm-search {
      min-width: auto;
      width: 100%;
    }
    
    .fm-toolbar {
      justify-content: stretch;
    }
  }
  
  @media (max-width: 768px) {
    .fm-integrations {
      min-height: auto;
      gap: 12px;
    }
    
    .fm-sidebar {
      padding: 8px;
    }
    
    .fm-content-area {
      padding: 12px;
    }
    
    .fm-header {
      margin-bottom: 16px;
    }
    
    .fm-main-title {
      font-size: 22px;
    }
    
    .fm-subtitle {
      font-size: 14px;
    }
    
    .fm-header-actions {
      flex-direction: column;
      gap: 8px;
      align-items: stretch;
    }
    
    .fm-btn {
      justify-content: center;
      width: 100%;
    }
    
    .fm-category-list {
      display: flex;
      gap: 6px;
      overflow-x: auto;
      padding-bottom: 8px;
      scrollbar-width: thin;
    }
    
    .fm-category-list::-webkit-scrollbar {
      height: 4px;
    }
    
    .fm-category-list::-webkit-scrollbar-track {
      background: #f1f1f1;
      border-radius: 2px;
    }
    
    .fm-category-list::-webkit-scrollbar-thumb {
      background: #c1c1c1;
      border-radius: 2px;
    }
    
    .fm-category-btn {
      white-space: nowrap;
      min-width: max-content;
      font-size: 13px;
      padding: 8px 12px;
    }
    
    .fm-sidebar-title {
      font-size: 14px;
      margin-bottom: 8px;
    }
    
    .fm-toolbar {
      margin-bottom: 16px;
    }
    
    .fm-search {
      min-width: 280px;
      padding: 8px 12px;
    }
    
    .fm-search-input {
      font-size: 14px;
    }
  }
  
  @media (max-width: 480px) {
    .fm-content-area {
      padding: 8px;
    }
    
    .fm-header {
      margin-bottom: 12px;
    }
    
    .fm-main-title {
      font-size: 20px;
    }
    
    .fm-subtitle {
      font-size: 13px;
    }
    
    .fm-btn {
      font-size: 13px;
      padding: 8px 12px;
    }
    
    .fm-search {
      min-width: 240px;
      padding: 6px 10px;
    }
    
    .fm-toolbar {
      margin-bottom: 12px;
    }
    
    .fm-category-btn {
      font-size: 12px;
      padding: 6px 10px;
    }
  }
  </style>